var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787598,
    y: 0.5,
    width: 5.36486,
    height: 5.17765,
    rx: 0.5,
    stroke: "#252525"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.70947,
    y: 0.5,
    width: 5.36486,
    height: 5.17765,
    rx: 0.5,
    stroke: "#252525"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.70947,
    y: 7.21875,
    width: 5.36486,
    height: 5.17765,
    rx: 0.5,
    stroke: "#252525"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.787598,
    y: 7.21875,
    width: 5.36486,
    height: 5.17765,
    rx: 0.5,
    stroke: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDashboard);
export default __webpack_public_path__ + "static/media/MyDashboard.9e72a0859981947f47a256008c760de3.svg";
export { ForwardRef as ReactComponent };